import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EquipamentoService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  // listar Equipamentos
  list(params?: any): Observable<any> {
    return this.apiService.get(`/api/Equipamentos`, params ? new HttpParams({
      fromObject: params
    }) : this.params,
    ).pipe(
      map(response => response)
    );
  }

  //listar por id
  show(id: any): Observable<any> {
    return this.apiService.get(
      `/api/Equipamentos/${id}`,
    ).pipe(
      map(response => response)
    );
  }

  /**
* Cria uma nova Equipamento
* @param Equipamento
* @returns Observable<any>
*/
  public store(Equipamento: any): Observable<any> {
    return this.apiService.post(`/api/Equipamentos`, Equipamento);
  }

  // atualizar Equipamento
  update(Equipamento: any, id: any): Observable<any> {
    return this.apiService.put(`/api/Equipamentos/${id}`, Equipamento);
  }

  delete(id: string): Observable<any> {
    return this.apiService.delete(`/api/Equipamentos/${id}`);
  }
}